<script setup lang="ts">
import VHeading from '@shared/typography/VHeading/VHeading.vue';
import { computed } from 'vue';
import { type CrmMedewerkersGetMedewerkersVoorContactpaginaMedewerker } from '@services/crm-public/orval-api/model/crmMedewerkersGetMedewerkersVoorContactpaginaMedewerker';
import ContactAvatar from './ContactAvatar.vue';
import ContactLink from './ContactLink.vue';

const props = defineProps<{
  gebruiker: CrmMedewerkersGetMedewerkersVoorContactpaginaMedewerker;
}>();

const imageUrl = computed(() =>
  props.gebruiker.gebruikerId ? `/gebruikerimages/${props.gebruiker.gebruikerId}.jpg` : undefined,
);
</script>

<template>
  <div class="flex flex-col rounded-lg bg-white shadow-sm transition-shadow hover:shadow-md">
    <ContactAvatar :image-url="imageUrl" :name="props.gebruiker.volledigeNaam" size="large" />
    <div class="flex grow flex-col px-4 py-3">
      <div class="grow">
        <VHeading :level="3" appearance="sm">
          {{ props.gebruiker.volledigeNaam }}
        </VHeading>
        <p class="text-sm text-grey-500">
          {{ props.gebruiker.functie ? ` ${props.gebruiker.functie}` : '' }}
        </p>
      </div>
      <div class="mt-2 space-y-1">
        <p v-if="props.gebruiker.email" class="truncate text-sm text-grey-500">
          <ContactLink type="email" :value="props.gebruiker.email" />
        </p>
        <p v-if="props.gebruiker.telefoonnummer" class="text-sm text-grey-500">
          <ContactLink type="phone" :value="props.gebruiker.telefoonnummer" />
        </p>
      </div>
    </div>
  </div>
</template>
